import React from "react";
import { classNames } from "../../helpers/classNames";

const Progress = ({ progress = 0, strokeWidth = 6, className }) => {
  const radius = 47 - (strokeWidth + 6);
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <div
      role="progressbar"
      aria-valuenow={progress}
      aria-valuemin={0}
      aria-valuemax={100}
      className={classNames(
        "flex items-center justify-center w-24 h-24 relative",
        className
      )}
    >
      <svg viewBox="0 0 100 100" className="w-full h-full transform -rotate-90">
        <circle
          r={radius}
          cx={50}
          cy={50}
          stroke="#e5e7eb"
          strokeWidth={strokeWidth}
          fill="transparent"
        />
        <circle
          r={radius}
          cx={50}
          cy={50}
          stroke="#ca4d55"
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={offset}
          strokeLinecap="round"
          className="transition-all duration-300"
        />
      </svg>
      <span className="absolute text-lg font-semibold text-gray-700">
        {progress}%
      </span>
    </div>
  );
};

export default Progress;
